import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import {requests} from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'PhoneSystemService'
const host = servicesConfig.PhoneSystem
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

const PhoneSystemService = {
  recordingsMeta: (locationId: string, body: any) =>
    request().post(
      `/location/${locationId}/recordings/meta`,
      body
    ),
  recording: (locationId: string, recordingSid: string) =>
    request().get(
      `/location/${locationId}/recordings/${recordingSid}`, {
        responseType: 'blob'
      }
    ),
  getRateLimitDetails: (locationId: string) =>
    request().get(
      `/rate-limiter/location/${locationId}/rate-limit`
    ),

  getPhoneNumbers: (locationId: string) =>
    request().get(
      `/numbers/location/${locationId}`
    ),

  getWhatsAppNumbers: (locationId: string) => 
    request().get(
      `/whatsapp/location/${locationId}/phone-numbers`
    ),
}

export default PhoneSystemService
